
import TiwiMixin from '../mixins/TiwiMixin';

export default {
  mixins: [TiwiMixin],
  props: {
    taxonomy: {
      required: false,
      type: String,
      default: 'tags'
    },
    limitTo: {
      required: false,
      type: Number,
      default: 10
    },
    enableShowMore: {
      required: false,
      type: Boolean,
      default: true
    },
    tagPrefix: {
      required: false,
      type: String,
      default: '#'
    },
    isLinks: {
      required: false,
      type: Boolean,
      default: false
    },
    linkBase: {
      required: false,
      type: String,
      default: '/tag/'
    }
  },
  data() {
    return {
      tags: [],
      showMore: false
    }
  },
  mounted() {
    this.fetchTags();
  },
  methods: {
    fetchTags() {
      const self = this;

      this.api.post('/tax-query/find', { taxonomy: this.taxonomy, pluck: false })
        .then((response) => {
          if (response.data.success) {
            self.updateTagCloud(response.data.terms);
          }
        });
    },

    updateTagCloud(tags) {
      this.allTags = tags;
      this.tags = tags.sort((a, b) => b.count - a.count).slice(0, this.showMore ? 20 : this.limitTo);
    },
    toggleShowMore() {
      this.showMore = !this.showMore;
      this.updateTagCloud(this.allTags);
    }
  },
}
